import React from 'react';
import styled from 'styled-components/macro';
import {
  LinkButton, Heading3, Heading4, Paragraph,
} from '../typography';
import Modal from '../Modal';
import ReadMore from '../ReadMore';

const StyledModal = styled(Modal)`
  z-index: 99999999999;
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.colorWhite};
  border: 2px ${({ theme }) => theme.colors.colorGreyLightAlt} solid;
  outline: none;
  overflow-y: hidden;
  overflow-x: hidden;
  
  width: 550px;
  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;

  @media (max-width: 991px) {
    width: 400px;
    padding: 10px;
  }

  @media (max-width: 767px) {
    width: 280px;
    padding: 10px;
  }

  @media (max-height: 572px) {
    top: 100px !important;
    height: calc(80% - 100px);
    margin-top: 0px;
    transform: translate(-50%, 0) !important;
    overflow-y: scroll;
  }
`;
export default ({ isOpen, onClose, onRedirect }) => (
  <StyledModal
    isOpen={isOpen}
    onRequestClose={onClose}
  >
    <Heading3>Du har ikke valgt fadølsanlæg</Heading3>
    <Heading4>
      Skal du bruge fadølsanlæg?
    </Heading4>
    <Paragraph>
      <LinkButton check action justifyCenter onClick={onRedirect}>
        Ja, vis mig hvor de er
      </LinkButton>
    </Paragraph>
    <Paragraph>
      <LinkButton small cart action justifyCenter onClick={onClose}>
        Nej, gå videre til kassen
      </LinkButton>
    </Paragraph>
    <ReadMore>
      <Paragraph fontSize="12px">
        Du skal bruge et fadølsanlæg for at tappe øl fra fustagerne. Til alle vores anlæg medfølger kulsyre.
      </Paragraph>
      <Paragraph fontSize="12px">
        Til dig der har eget anlæg:
        <br />
        Vær opmærksom på om koblingen på dit anlæg passer til de fustager du har bestilt.
      </Paragraph>
      <Paragraph fontSize="12px">
        Fustagerne du køber kan du beholde så længe du vil.
        Hvis du ikke lejer udstyr opkræver vi pant på fustagerne.
        Du vil få panten retur når du returnerer fustagerne, uanset hvor lang tid det varer.
      </Paragraph>
    </ReadMore>
  </StyledModal>
);
